

































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import { asyncForEach } from "@/utils";
import _ from "lodash";

@Component({
	name: "order-filters-modal",
	computed: {},
})
export default class OrderDetailModal extends Vue {
	//
	private activeOrder!: any;
	private activeOrderLoading!: any;

	private searchQuery: string = "";
	public selectedOrders: string = '';
	public optionsOrders: any = [
		{ text: 'Confirmada', value: 'confirmed' },
		{ text: 'Pago requerido', value: 'payment_required' },
		{ text: 'Pago en proceso', value: 'payment_in_process' },
		{ text: 'Pagada parcialmente', value: 'partially_paid' },
		{ text: 'Pagada', value: 'paid' },
		{ text: 'Cancelada', value: 'cancelled' }
	];

	public selectedShipment: string = '';
	public optionsShipment: any = [
		{ text: 'A convenir', value: 'to_be_agreed' },
		{ text: 'Pendiente', value: 'pending' },
		{ text: 'Listo para enviar', value: 'ready_to_ship' },
		{ text: 'Enviada', value: 'shipped' },
		{ text: 'Entregada', value: 'delivered' },
		{ text: 'No entregada', value: 'not_delivered' },
		{ text: 'Cerrada', value: 'closed' },
		{ text: 'Etiqueta impresa', value: 'printed' },
		{ text: 'Etiqueta lista para imprimir', value: 'ready_to_print' },
		{ text: 'En lista de empaque', value: 'in_packing_list' },
		{ text: 'Procesando en la bodega', value: 'in_warehouse' },
		{ text: 'En camino', value: 'out_for_delivery' },
		{ text: 'Retrasada', value: 'delayed' },
		{ text: 'Receptor ausente', value: 'receiver_absent' },
		{ text: 'Esperando el retiro', value: 'waiting_for_withdrawal' },
		{ text: 'Listo para empacar', value: 'ready_to_pack' }
	];

	public selectedClaimReturn: string = '';
	public optionsClaimReturn: any = [
		{ text: 'Abierto', value: 'opened' },
	];

	get permalink() {
		return `https://www.mercadolibre.com.mx/ventas/${this.activeOrder.id}/detalle`;
	}

	getOrderUrl(id: string) {
		return `https://prodelec.mx/wp-admin/post.php?post=${id}&action=edit&classic-editor`;
	}

	onFilterOrder() {
		console.log('Filtrando ordenes...', this.selectedOrders);
		console.log('Filtrando envíos...', this.selectedShipment);
		console.log('Filtrando reclamos/devoluciones...', this.selectedClaimReturn);

		this.$router.push({
			path: "orders",
			query: {
				...this.$route.query,
				order_status_filter: this.selectedOrders,
				shipment_status_filter: this.selectedShipment,
				claim_return_status_filter: this.selectedClaimReturn
			}
		});
		this.$bvModal.hide('order-filters-modal');
	}

	clearFilters() {
		this.selectedOrders = '';
		this.selectedShipment = '';
		this.selectedClaimReturn = '';
		this.$router.push({
			path: "orders",
			query: {}
		});
	}
}
